import cloneDeep from 'lodash/cloneDeep';
import showdown from 'showdown/dist/showdown';

var richTextViewer = function richTextViewer() {
	// Render rich text widget
	var renderWidget = function renderWidget(widgetConfig) {
		var ContainerId = widgetConfig.ContainerId,
		    RichTextConfig = widgetConfig.RichTextConfig,
		    NoDataMessage = widgetConfig.NoDataMessage;


		var converter = new showdown.Converter({
			tables: true,
			tasklists: true,
			simpleLineBreaks: true,
			emoji: true
		});

		var el = document.querySelector('#' + ContainerId);
		var markdown = widgetConfig.Data != null && widgetConfig.Data.data != null && widgetConfig.Data.data.length > 0 ? widgetConfig.Data.data : RichTextConfig.Content;

		if (!markdown) {
			var noDataContainer = document.createElement('div');
			noDataContainer.setAttribute('class', 'no-data-container');
			noDataContainer.innerHTML = '<p class=\'no-data-message\'>' + NoDataMessage + '</p>';

			el.appendChild(noDataContainer);
			return;
		}

		var viewerContainer = document.createElement('div');
		viewerContainer.setAttribute('class', 'richtext-viewer-container');
		viewerContainer.setAttribute('style', 'display: flex; position: relative;');

		var viewer = document.createElement('div');
		viewer.setAttribute('class', 'richtext-viewer');
		viewer.setAttribute('style', 'display: block; position: relative;');
		viewer.innerHTML = converter.makeHtml(markdown);

		viewerContainer.appendChild(viewer);
		el.appendChild(viewerContainer);
	};

	// Initiate rendering for a widget
	var initiateWidgetRendering = function initiateWidgetRendering(widgetConfig) {
		renderWidget(cloneDeep(widgetConfig));
	};
	return {
		renderWidget: renderWidget,
		initiateWidgetRendering: initiateWidgetRendering
	};
};

export default richTextViewer();